export class createProjectStage {
  stagesId: number;
  state: number;
  startDate: string;
  endDate: string;
  projectsId: number;
  dependenceId: number;
}
